import MkuFormItem from '../form/src/form-item';

MkuFormItem.install = function (Vue) {
  Vue.component(MkuFormItem.name, MkuFormItem);
};

export default MkuFormItem;
